import { kartoyImages } from '@mobile/assets/kartoy'
import { KartoyChevronTinted } from '@mobile/components/kartoy/kartoy-icon'
import { useI18N } from '@shared-core/hooks/use-i18n'
import { FastImage } from '@shared-ui/components/ui/fast-image'
import { Gradient } from '@shared-ui/components/ui/gradient'
import { Column, Container, Row } from '@shared-ui/components/ui/grid'
import { GText } from '@shared-ui/components/ui/text'
import { useAppTheme, useCurrentColorPalette } from '@shared-ui/theme'
import { rw } from '@shared-ui/theme/scale'
import { memo, useId } from 'react'
import { Pressable, View } from 'react-native'
import Svg, { Defs, RadialGradient, Rect, Stop } from 'react-native-svg'

import locales from './index.i18n.json'
import { useCreateStyles } from './styles'

// Баннер «Добавьте телефон»: тёмный градиент, иллюстрация справа, ссылка «Добавить».
type PhoneBannerProps = { onPress: () => void }

function BannerBackground() {
  const theme = useAppTheme()
  const palette = useCurrentColorPalette()
  const styles = useCreateStyles()
  const gradientId = useId().replace(/:/g, '')

  if (palette !== 'dark') {
    return (
      <Gradient
        colors={[theme.COLOR_NEUTRAL_800, theme.COLOR_NEUTRAL_700, theme.COLOR_NEUTRAL_600]}
        end={{ x: 1, y: 0 }}
        start={{ x: 0.2, y: 0 }}
        style={styles.background}
        pointerEvents="none"
      />
    )
  }

  return (
    <View style={styles.background} pointerEvents="none">
      <Svg width="100%" height="100%" viewBox="0 0 345 156" preserveAspectRatio="none">
        <Defs>
          <RadialGradient
            id={gradientId}
            gradientUnits="userSpaceOnUse"
            cx={0}
            cy={0}
            r={10}
            gradientTransform="matrix(-5.789 15.539 -46.551 -17.342 230.39 25.23)"
          >
            <Stop offset={0} stopColor={theme.COLOR_NEUTRAL_400} />
            <Stop offset={0.29217} stopColor="#C2C2C8" />
            <Stop offset={0.58434} stopColor={theme.COLOR_NEUTRAL_150} />
          </RadialGradient>
        </Defs>
        <Rect width={345} height={156} fill={`url(#${gradientId})`} />
      </Svg>
    </View>
  )
}

export const PhoneBanner = memo(function PhoneBannerComponent({ onPress }: PhoneBannerProps) {
  const styles = useCreateStyles()
  const theme = useAppTheme()
  const palette = useCurrentColorPalette()
  const { t } = useI18N(locales)

  return (
    <Pressable onPress={onPress} style={styles.banner}>
      <BannerBackground />
      <Container style={styles.bannerContent}>
        <Column gap={12} style={styles.copy}>
          <GText fw={600} style={styles.title}>
            {t('title')}
          </GText>
          <GText style={[styles.text, palette === 'dark' && styles.textDark]}>{t('text')}</GText>
          <Row align="center" gap={4}>
            <GText fw={600} style={styles.action}>
              {t('add')}
            </GText>
            <KartoyChevronTinted color={theme.COLOR_TEXT_INVERSE_PRIMARY} size={rw(20)} />
          </Row>
        </Column>
        <View style={styles.artWrap}>
          <View style={styles.art}>
            <FastImage source={kartoyImages.phoneIllustration} style={styles.artImage} resizeMode="cover" />
          </View>
        </View>
      </Container>
    </Pressable>
  )
})
